import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceAppsCreateRoute } from '@/pages/workspaces/settings/actions/apps/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/apps/create')({
  component: WorkspaceAppsCreateRoute,
});
